import { TTemplateSource } from '@modules/items';

type TWithTemplateSource = { templateSource?: TTemplateSource };

// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/documents/src/templateHelpers.ts
/**
 * Returns true when a version or draft is "bound" - linked to a template with
 * live field values. Bound versions have no standalone HTML blob; their content
 * is composed on-the-fly from the template structure + field-value blob.
 *
 * Detached clones carry templateSource.versionId but no fieldValuesBlobName,
 * so they return false.
 */
export const isVersionBound = (version?: TWithTemplateSource | null): boolean =>
  !!version?.templateSource?.fieldValuesBlobName;

export const isVersionDetached = (version?: TWithTemplateSource | null): boolean =>
  !!version?.templateSource && !isVersionBound(version);

export const hasTemplateSource = (version?: TWithTemplateSource | null): boolean => !!version?.templateSource;
